<template>
  <div class="login-box">
    <a
      href="https://www.aidprint.com"
      class="site-home link-btn-hover"
      target="_blank"
      rel="noopener noreferrer"
    >{{words.siteHome}}</a>
    <div class="login-content">
      <div class="image-box">
        <p class="title">{{words.Mobileprintingismoreconvenient}}</p>
        <div class="down">
          <p class="text">{{words.Downloadmobileapp}}</p>
          <div class="qrcode">
            <img :src="AppCode" alt class="code" />
          </div>
        </div>
        <img :src="background" alt class="bg" />
      </div>

      <!-- 绑定手机 -->
      <div class="login-box-from">
        <img :src="closeBtn" alt="关闭" class="passBtn" @click="$lfy.Jump.Back()" />
        <img :src="Logo" alt class="logo" />
        <div class="from-box">
          <div class="item">
            <input
              type="text"
              :placeholder="words.Pleaseenterthephonenumber"
              maxlength="11"
              class="input"
              v-model="info.tel"
            />
          </div>
          <div class="item">
            <input
              type="text"
              class="input"
              maxlength="6"
              :placeholder="words.SmsCode"
              v-model="info.code"
            />
            <p
              class="passzh-btn"
              v-if="!SmsCodeData.status"
              @click="getMobileCode"
            >{{words.getverificationcode}}</p>
            <p class="get-code-btn" v-else>{{SmsCodeData.num}}S</p>
          </div>
          <div class="login-btn" @click="login">{{words.login}}</div>
          <!-- <div class="tips">企业员工请联系管理员找回密码</div> -->
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { mapGetters, mapActions } from "vuex";
import config from "../../config";
import { setTimeout } from "timers";

export default {
  components: {},
  data() {
    return {
      code: "",
      background: require("../../assets/login_bg.png"),
      closeBtn: require("../../assets/close.png"),
      Logo: require("../../assets/logo-black.png"),
      AppCode: require("../../assets/app_code.png"),
      info: {
        tel: "",
        code: ""
      },
      SmsCodeData: {
        status: false,
        num: 60
      },
      setInterval: false,
      wechatUser: {
        openid: "",
        nickname: "",
        sex: "",
        unionid: "",
        headimgurl: ""
      }
    };
  },
  mounted() {
    this.code = this.$route.query.code;
    this.getWechatInfo();
  },
  created() {},
  methods: {
    ...mapActions([
      "GetWechatUserInfo",
      "setUser",
      "GetCode",
      "UserMobileLogin"
    ]),
    getWechatInfo() {
      this.$Spin.show();
      this.GetWechatUserInfo({ code: this.code }).then(res => {
        this.$Spin.hide();
        if (res.code === 5) {
          this.wechatUser = res.data;
          this.$Message.error(res.msg);
        } else if (res.code === 1) {
          this.loginCallback(res.data);
        } else {
          this.$Message.error(res.msg);
          // this.$lfy.Jump.Redirect("/");
        }
      });
    },
    loginCallback(data) {
      this.setUser(data);
      this.$lfy.Jump.Redirect("/main");
    },
    getMobileCode() {
      let params = {
        tel: this.info.tel,
        mode: 0
      };
      if (!params.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(params.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if (this.SmsCodeData.status) return false;
      this.SmsCodeData.status = true;
      this.GetCode(params).then(res => {
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          this.SmsCodeData.status = false;
          return false;
        }
        this.setInterval = setInterval(() => {
          this.SmsCodeData.num--;
          if (this.SmsCodeData.num < 1) {
            clearInterval(this.setInterval);
            this.setInterval = {};
            this.SmsCodeData = {
              num: 60,
              status: false
            };
          }
        }, 1000);
      });
    },
    login() {
      let params = {
        tel: this.info.tel,
        checkcode: this.info.code,
        union_id: this.wechatUser.unionid,
        web_openid: this.wechatUser.openid,
        unionid: this.wechatUser.unionid,
        headimgurl: this.wechatUser.headimgurl,
        nickname: this.wechatUser.nickname,
        sex: this.wechatUser.sex
      };
       if (!params.tel) {
        this.$Message.error(this.words.Pleaseenterthephonenumber);
        return false;
      }
      if (!this.$lfy.check.checkMobile(params.tel)) {
        this.$Message.error(this.words.phonenumberError);
        return false;
      }
      if(!params.checkcode){
        this.$Message.error('请输入验证码');
        return false;
      }
      this.$Spin.show();
      this.UserMobileLogin(params).then(res => {
        console.log(res);
        this.$Spin.hide();
        if (res.code !== 1) {
          this.$Message.error(res.msg);
          return false;
        }
        this.loginCallback(res.data);
      });
    }
  },
  computed: mapGetters({
    words: "words",
    user: "user"
  })
};
</script>



<style lang="scss" scoped>
@import "./index.scss";
</style>